


















































































































































import Vue from 'vue'
import { PagedCases } from '@/queries/cases.graphql'
import { CaseNodeFragment, CasesOrderBy } from '@/graphql-schema'

export default Vue.extend({
  apollo: {
    cases: {
      query: PagedCases,
      fetchPolicy: 'cache-and-network',
      variables() {
        return {
          first: this.first,
          offset: this.offset,
          orderBy: this.orderBy,
          search: this.search || null,
          stage: this.filterStage,
          filterUnassigned: this.filterUnassigned,
        }
      },
    },
  },
  computed: {
    first(): number {
      return this.pageSize
    },
    offset(): number {
      return this.page * this.pageSize
    },
  },
  created() {
    this.refreshCasesList()
  },
  data() {
    return {
      cases: { nodes: [] },
      page: 0,
      pageSize: 100,
      search: '',
      filterUnassigned: false,
      filterStage: '',
      orderBy: [CasesOrderBy.Natural],
    }
  },
  methods: {
    refreshCasesList(): void {
      this.$apollo.queries.cases.refresh()
    },
    nextPage(): void {
      this.page++
    },
    previousPage(): void {
      this.page = Math.max(0, this.page - 1)
    },
  },
  watch: {
    $route: 'refreshCasesList',
  },
})
